// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import LinkEdit from "@synd/XDL/Icons/LinkEdit";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { createLinkIconStyles, mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export const xAddressStyle: TypographyProps = {
    ...fontConfig.smallSingleLine,
    css: css`
        @media print {
            display: block;
        }
    `,
};

export const editAddressLink: LinkPresentationProps = {
    ...createLinkIconStyles({
        icon: LinkEdit,
        sizeVariant: "xsmall",
        linkStyles: {
            css: css`
                display: flex;
                justify-content: center;
                margin-top: 12px;
                margin-left: auto;
            `,
            typographyProps: {
                weight: fontConfig.weight.bold,
            },
        },
    }),
};

const AddressSharedStyles: { address: AddressInfoDisplayStyles; warehouseNameText: TypographyProps } = {
    address: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                font-style: normal;
                height: 100%;
                @media print {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                }
            `,
        },
        address1Text: xAddressStyle,
        address2Text: xAddressStyle,
        address3Text: xAddressStyle,
        address4Text: xAddressStyle,
        attentionText: xAddressStyle,
        cityText: xAddressStyle,
        companyNameText: xAddressStyle,
        faxText: xAddressStyle,
        firstNameText: xAddressStyle,
        lastNameText: xAddressStyle,
        postalCodeText: xAddressStyle,
        stateText: xAddressStyle,
        cityStatePostalCodeText: mergeWithCss(xAddressStyle, {
            css: css`
                @media print {
                    display: inline-flex;
                }
            `,
        }),
        countryText: xAddressStyle,
        customerNameText: {
            ...mergeWithCss(xAddressStyle, {
                css: css`
                    display: flex;
                    gap: 4px;
                    @media print {
                        display: inline-flex;
                    }
                `,
            }),
        },
        phoneText: {
            ...mergeWithCss(xAddressStyle, {
                css: css`
                    margin-top: auto;
                    padding-top: 8px;
                `,
            }),
        },
        emailText: {
            ...mergeWithCss(xAddressStyle, {
                css: css`
                    margin-top: 8px;
                `,
            }),
        },
    },
    warehouseNameText: xAddressStyle,
};

export default AddressSharedStyles;
